// extracted by mini-css-extract-plugin
export default {"quiz":"Quizzes_quiz__9+9jH"};